import { Box, SystemProps } from "@storyofams/react-ui";

type CodeEmbedProps = {
  content: {
    code: string;
  };
} & SystemProps;

export const CodeEmbed = ({ content, ...props }: CodeEmbedProps) => {
  return <Box {...props} dangerouslySetInnerHTML={{ __html: content?.code }} />;
};
